import {getRefinementExpandClass} from '../../../../helper';
import refinementInclude from './types/refinement-include';
import sizeRegionDropdown from './types/size-refinement/region-dropdown';

/**
 * @param {import('../../../../type-definitions').Refinement} refinement - Search result
 * @param {import('../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} refinement dropdown HTML
 */
export default (refinement, refinementURLBuilder, seoUrlConfig) => {
    if (refinement.options.length === 0) {
        return '';
    }
    const expandClass = getRefinementExpandClass(refinement.baseID);
    return `
        <li class="refinement ${refinement.baseID}" data-attrid="${refinement.id}">
            <div class="refinement-dropdown">
                <div class="refinement-select toggle ${expandClass}">
                    <div class="refinement-select-inner" aria-label="${refinement.name}" tabindex="0">
                        <input type="hidden" name="filterType" value="${
                            window.Resources[`DY_FILTER_${refinement.baseID.toUpperCase()}`]
                        }">
                        <span>${refinement.name}</span>
                        ${refinement.isSizeRefinement ? sizeRegionDropdown(refinement.sizeMap) : ''}
                        <span class="plus-minus-icon" aria-hidden="true"></span>
                    </div>
                </div>
                <div class="refinement-option-list toggle-content">
                    <div class="dropdown-inner ${window.SitePreferences.IS_US_STYLE ? 'us-region' : ''}">
                        ${refinementInclude(refinement, refinementURLBuilder, seoUrlConfig)}
                    </div>
                </div>
            </div>
        </li>
    `;
};
